import React from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import { IDotMenu } from '@app/models';

interface IProps {
    id: string;
    options: IDotMenu[];
}

export function PasslyDotMenu(props: IProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return props.options.length ? (
        <>
            <IconButton id='passlyDotMenuButton' aria-label='more' aria-controls='id' aria-haspopup='true' onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu id='id' anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
                {props.options.map(
                    (option, index) =>
                        (option.permitted === undefined || option.permitted) && (
                            <MenuItem
                                id={props.id}
                                key={index}
                                onClick={(event) => {
                                    handleClose();
                                    option.action(event);
                                }}
                            >
                                {option.name}
                            </MenuItem>
                        )
                )}
            </Menu>
        </>
    ) : null;
}
